function isImageElement(node) {
    return node?.nodeType === 1 && node.nodeName === 'IMG';
}

export function stripImageSizeAttributes(img) {
    if (!isImageElement(img)) {
        return false;
    }
    const hadSize = img.hasAttribute('width') || img.hasAttribute('height');
    img.removeAttribute('width');
    img.removeAttribute('height');
    return hadSize;
}

export function stripPastedImageSizeAttributes(root) {
    if (!root?.querySelectorAll) {
        return 0;
    }

    let count = 0;
    root.querySelectorAll('img').forEach(img => {
        if (stripImageSizeAttributes(img)) {
            count += 1;
        }
    });
    return count;
}
